// extracted by mini-css-extract-plugin
module.exports = {"delete-button-container":"_1QiQ4KpSK7Z8fBDzLWzC"};